<template>
  <div class="stepBox">
    <!-- <van-steps :active="active" :active-color="mainColor">
      <van-step>注册登记</van-step>
      <van-step>基本信息</van-step>
      <van-step>问卷调查</van-step>
      <van-step>登记成功</van-step>
    </van-steps> -->
    <van-steps
      :active="active"
      inactive-icon="arrow"
      active-icon="success"
      :active-color="mainColor"
    >
      <!-- <van-step>注册登记</van-step> -->
      <van-step>Information</van-step>
      <van-step v-if="gconfig.IsHaveQuestion === 'True'"
        >Questionnaire</van-step
      >
      <van-step>Complete</van-step>
    </van-steps>
  </div>
</template>
<script setup>
import { decryptionECB } from '@/utils/utils.js'
import { defineProps, computed } from 'vue'
// import { vanStep, vanSteps } from 'vant'
import { useStore } from 'vuex'
const store = useStore()
const mainColor = computed(() => store.state.mainColor)
// 全局配置
const getConfigObj = (configStr) => {
  const configObj = {}
  if (configStr) {
    const resObj = JSON.parse(decryptionECB(configStr))
    resObj.forEach((item) => {
      configObj[item.GlobalKey] = item.GlobalEValue
    })
  }
  return configObj
}
const gconfig = computed(() => getConfigObj(store.state.gconfig))
// console.log(gconfig.value, '444')

const props = defineProps({
  active: {
    type: Number,
    default: () => 0
  }
})
console.log(props)
</script>
<style lang="less">
.stepBox {
  background: #17AADF;
  padding-bottom: 10px;
  border-radius: 10px;
  height: 80px;
  overflow: hidden;
  width: 92%;
  margin: 0 auto;
  .van-steps {
    background: transparent;
  }
  .van-steps--horizontal {
    padding: 15px 40px 0;
  }
  .van-step__line {
    margin-top: 5px;
    background: #ffffff !important;
  }
  .van-step--horizontal .van-step__circle-container {
    background: #f9f9f9;
    margin-top: 5px;
    border-radius: 50%;
    width: 4vw;
    height: 4vw;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .van-step--horizontal:first-child .van-step__title {
    margin-left: -20px;
  }
  .van-step--horizontal:last-child .van-step__title {
    margin-right: -20px;
    color: #f9f9f9;
  }
  .van-step__title.van-step__title--active {
    color: #0730E3 !important;
  }
  .van-step__title.van-step__title--active + .van-step__circle-container {
    background: #0730E3;
    .van-step__icon {
      color: #fff !important;
    }
  }
  .van-step__title {
    color: #f9f9f9;
    font-size: 14px;
  }

  @media screen and (min-width: 768px) {
    .van-step--horizontal .van-step__title {
      font-size: 14px;
      font-weight: bold;
      color: #f9f9f9;
    }
    .van-step--horizontal .van-step__circle-container {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
